import { Link } from 'react-router-dom';
import { articles } from '@/mocks/anime';

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="article-title">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 id="article-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            动漫资讯
          </h2>
          <p className="text-sm text-foreground-500">最新动漫资讯与深度分析</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/anime/${article.relatedAnimeIds[0]}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2.5">
                  <span className="text-[10px] font-medium text-primary-700 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-user-line"></i>
                  <span>{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}